import React, { useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export var PortalContext = /*#__PURE__*/React.createContext(undefined);
export var usePortal = function usePortal() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    portalFromProps = _ref.portal;
  var portalFromContext = useContext(PortalContext);
  if (portalFromProps) {
    return portalFromProps;
  }
  if (fg('cc_complexit_reduce_portal_rerenders')) {
    return portalFromContext;
  }
  return undefined;
};